//Gallery Slider & Home JS
jQuery(document).ready(function(){
    jQuery('.js-gallery-slider').slick({
        arrows:true,
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="24.433" height="47.224" viewBox="0 0 24.433 47.224"><path d="M1502,3332.066l22.741-21.277,22.426,21.277" transform="translate(-3308.729 1548.199) rotate(-90)" fill="none" stroke="#000000" stroke-width="3"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="24.433" height="47.224" viewBox="0 0 24.433 47.224"><path d="M0,0,22.741,21.277,45.167,0" transform="translate(1.095 46.199) rotate(-90)" fill="none" stroke="#000000" stroke-width="3"/></svg></button>',
	    //prevArrow:'<button type="button" class="slick-prev slick-arrow" aria-label="Previous"></button>',
	    //nextArrow:'<button type="button" class="slick-next slick-arrow" aria-label="Next"></button>',
        infinite: true,
        cssEase: 'linear',
        centerMode: true,
        centerPadding: '180px',
        slidesToShow: 1,
        responsive: [
        {
            breakpoint: 1200,
            settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '75px',
            slidesToShow: 1
            }
        },
        {
            breakpoint: 992,
            settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 1
            }
        }
        ]
    });
});

jQuery(document).ready(function(){

    jQuery('.js-floor-slider').slick({
        arrows:true,
        //prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"></button>',
        //nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"></button>',
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="24.433" height="47.224" viewBox="0 0 24.433 47.224"><path d="M1502,3332.066l22.741-21.277,22.426,21.277" transform="translate(-3308.729 1548.199) rotate(-90)" fill="none" stroke="#000000" stroke-width="3"/></svg></button>',
        nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="24.433" height="47.224" viewBox="0 0 24.433 47.224"><path d="M0,0,22.741,21.277,45.167,0" transform="translate(1.095 46.199) rotate(-90)" fill="none" stroke="#000000" stroke-width="3"/></svg></button>',
        slidesToShow: 1,
        centerMode: false,
        autoplay: false,

        responsive: [
            {
            breakpoint: 980,
            settings: {
                arrows:true,
                dots:false,
                slidesToShow: 1
            }
            },
            { 
            breakpoint: 767,
            settings: {
                arrows:true,
                dots: false,
                slidesToShow: 1
            }
            }
        ]
    });

});


// Close dropdown menu when user clicks outside the menu

//Ensure DOM is loaded first
document.addEventListener('DOMContentLoaded', function () {

    const toggleInput = document.getElementById('js-menu-toggle');
    const dropdown = document.getElementById('js-dropdown');
    
    // Function to close the dropdown menu
    function closeDropdown() {
        toggleInput.checked = false;
    }

    // Add a change event listener to the toggle input
    toggleInput.addEventListener('change', function () {
        if (toggleInput.checked) {
            // If the input is checked, add a click event listener to close the menu when clicking outside
            document.addEventListener('click', function closeMenuOnClickOutside(event) {
                if (!dropdown.contains(event.target) && event.target !== toggleInput) {
                    closeDropdown();
                    document.removeEventListener('click', closeMenuOnClickOutside); // Remove the click event listener
                }
            });
        }
    });

});


// Neighborhood Page - Map Legend Buttons

jQuery(document).ready(function($) {
    $('.js-map-cat-filter').click(function() {
        // Get the category ID from the clicked filter
        var categoryId = $(this).data('category'); 
        var checkboxId = 'wpgmza_cat_checkbox_' + categoryId;
        $('#' + checkboxId).click();

        //Add active class to the clicked filter button and remove from previously clicked button
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $('.js-map-cat-filter').removeClass('active');
            $(this).addClass('active');
        }
    });

    $('.wpgmza_checkbox').on('click', function() {
        $('.wpgmza_checkbox').not(this).prop('checked', false);
    });
});